import { Watermark } from 'antd';
import styled from 'styled-components';

export default styled(Watermark)`
	// Add your styles here
`;
